import { useQuery } from '@tanstack/react-query';

import apiClient from 'apiClient';

import { type SubRegion } from '../data-contracts';

export const useGetStates = (countryCode = 'US') => {
  return useQuery<SubRegion[], Error>({
    queryFn: async () => {
      return apiClient.get(`regions/${countryCode}/subregions`);
    },
    queryKey: ['regions', countryCode],
  });
};
